<template>
  <div>
    <loading v-show="showLoading"></loading>
    <div v-show="!showLoading" class="goods-eval-back">

      <!--<div class="nav_bar clear_both">-->
        <!--<button class="fl nav_bar_left_item" >-->
          <!--<img class="nav_item_btn" src="@/images/back.png" @click="$router.back(-1)" >-->
        <!--</button>-->
        <!--<div class="order-bar-title">-->
          <!--商品评价-->
        <!--</div>-->
      <!--</div>-->

      <div>
        <div class="tag-content" v-if="tagList.length>0">
          <div class="tag-content-each">
            <button v-for="(tag,index) in tagList" :key="index" v-bind:class="[tag.selected == true?'tag-content-each-choice':'tag-content-each-noChoice']" @click="choiceTag(tag.tagId)">
              {{tag.tagName}}({{tag.tagNum}})
            </button>
          </div>
        </div>

        <div class="goods-eval-comment">
          <refresh style="position:relative;-webkit-overflow-scrolling : touch;overflow:auto;margin-bottom:45px;" @zj-load="loadMore" :lastPage='{total: !allLoaded, empty: commentList.length,show:show}'>
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
              <div class="goods-eval-comment-list">
                <div class="goods-eval-comment-each" v-for="(comment,index) in commentList" :key="index">
                  <div class="goods-eval-comment-each-head">
                    <div class="goods-eval-comment-each-partyImg">
                      <van-image :src="comment.partyImage">
                        <template v-slot:error></template>
                      </van-image>
                    </div>
                    <div class="goods-eval-comment-each-partyName">
                      {{comment.partyName}}
                    </div>
                  </div>
                  <div class="goods-eval-comment-each-time">
                    {{comment.postedDateTime|formatDate}}
                  </div>
                  <div class="goods-eval-comment-each-content">
                    {{comment.productReview}}
                  </div>
                  <div class="goods-eval-comment-each-photo">
                    <van-image v-for="(image,index) in comment.imageList" :key="index" :src="image">
                      <template v-slot:error></template>
                    </van-image>
                  </div>
                </div>
              </div>
            </van-pull-refresh>
          </refresh>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { storeName,prodCatalogId } from '@/router/Constant'
  import { getProductReviews} from '@/router/api'
  import { NavBar, Image, Grid, Tabbar, Toast,PullRefresh} from 'vant'
  import loading from '@/components/page/common/loading.vue'
  import {setStore,getStore} from "../../../utils/mUtil";
  import refresh from '@/components/page/common/refresh.vue';

  export default {
    name: "goodsEvaluation",
    data(){
      return{
        showLoading:true,
        token:getStore('externalLoginKey'),
        productId:this.$route.query.productId,
        productStoreId:storeName,
        viewIndex:0,
        viewSize:10,
        tagId:'',
        tagList:[],
        commentList:[],
        allLoaded: false,
        isLoading:false,
        show:false
      }
    },

    filters: {
      formatDate: function (value) {
        if(value!=null&&value!=''&&value!=undefined ){
          let date = new Date(value)
          let y = date.getFullYear()
          let MM = date.getMonth() + 1
          MM = MM < 10 ? ('0' + MM) : MM
          let d = date.getDate()
          d = d < 10 ? ('0' + d) : d
          let h = date.getHours();
          h = h < 10 ? ('0' + h) : h;
          let m = date.getMinutes();
          m = m < 10 ? ('0' + m) : m;
          let s = date.getSeconds();
          s = s < 10 ? ('0' + s) : s;
          return y + '-' + MM + '-' + d+'  '+h+':'+m
        }else{
          return ''
        }

      }
    },

    mounted(){
      this.initData()
      this.$router.afterEach((to, from, next) => {
        window.scrollTo(0, 0)
      })
      document.documentElement.scrollTop = 0
    },
    components:{
      [NavBar.name]: NavBar,
      [Image.name]: Image,
      [Grid.name]: Grid,
      [Tabbar.name]: Tabbar,
      [Toast.name]: Toast,
      loading,
      [PullRefresh.name]: PullRefresh,
      refresh
    },
    methods:{
      async initData() {
        this.getProductReviews();
      },

      //获取商品评论
      getProductReviews:function(){
        var params = {
          productId:this.productId,
          externalLoginKey:this.token,
          productStoreId:this.productStoreId,
          viewIndex:this.viewIndex,
          viewSize:this.viewSize,
          tagId:this.tagId
        }
        getProductReviews(params)
          .then(res => {
            console.log(res);
            this.showLoading = false;
            if(!this.tagId){
              for(var i = 0;i<res.tagList.length;i++){
                if(i == 0){
                  res.tagList[i].selected = true
                }else{
                  res.tagList[i].selected = false
                }
              }
              this.tagList = res.tagList
            }
            if (res.resultMap.commentList) {
              if (res.resultMap.commentList.length == 0){
                Toast("宝贝还没有评价");
              }

              if(res.resultMap.viewIndex==0){
                this.show = false
              }else{
                this.show = true
              }

              if (res.resultMap.commentList.length < res.resultMap.viewSize) {
                this.allLoaded = true
              } else {
                this.allLoaded = false
              }
              var oldProductList = this.commentList
              var newProductList = oldProductList.concat(res.resultMap.commentList)
              this.commentList = newProductList
            } else {
              Toast({message:"宝贝还没有评价"});
            }
          })
          .catch(err => {
            console.log(err);
          });
      },

      //用户选择商品标签
      choiceTag:function(tagId){
        for(var i = 0;i<this.tagList.length;i++){
          if(tagId == this.tagList[i].tagId){
            if(this.tagList[i].selected == true){
              this.tagList[i].selected = false
            }else{
              this.tagList[i].selected  = true
              this.tagId = tagId
            }
          }else{
            this.tagList[i].selected = false
          }
        }
        this.$forceUpdate();
        this.commentList  = []
        this.viewIndex = 0
        this.getProductReviews()
      },


      //上拉加载
      loadMore() {
        if (!this.allLoaded) {
          this.viewIndex ++;
          this.getOrderList()
        }
      },

      //下拉刷新
      onRefresh() {
        setTimeout(() => {
          this.commentList = []
          this.getProductReviews()
          this.isLoading = false
        }, 1000);
      },

    }


  }
</script>

<style>
  .goods-eval-back{
    width:100%;
    background-color: #F5F5F5;
  }

  .nav_bar {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    position: fixed;
    z-index: 99;
    width: 100%;
    background: white;
    opacity: 1;
    border-bottom: 1px solid #E1E1E1;
    display: block;
  }
  .nav_bar_left_item {
    padding-top: 0.3rem;
    width:3rem;
  }
  .nav_item_btn {
    width: 1.25rem;height: 1.25rem;
  }
  .order-bar-title{
    width:calc(100% - 3rem);
    text-align: center;
    font-size: 1rem;
    color:#333312;
    height: 2rem;
    line-height: 2rem;
  }

  /*评价标签*/
  .tag-content{
    width:100%;
    border-bottom: 1px solid #E7E7E7;
    /*padding-top: 3rem;*/
    background-color: white;
  }
  .tag-content-each{
    width:21.4375rem;
    margin: 0 auto;
    padding: 1rem 0 0;
  }
  .tag-content-each button{
    height: 1.40625rem;
    line-height: 1.40625rem;
    border-radius: 0.703125rem;
    display: inline-block;
    vertical-align: top;
    margin-right: 0.625rem;
    margin-bottom: 1rem;
    font-size: 0.75rem;
    padding: 0 0.46875rem;
  }
  .tag-content-each-choice{
    background-color: #FFB9C6;
    color:white;
  }
  .tag-content-each-noChoice{
    background-color: white;
    color:#666666;
    border: 1px solid #666;
  }

  /*商品评价*/
  .goods-eval-comment{
    width:100%;
  }
  .goods-eval-comment-more-icon img{
    width:100%;
    height: 100%;
  }
  .goods-eval-comment-tag div{
    background-color: #FFB9C6;
    height: 1.40625rem;
    line-height: 1.40625rem;
    color:white;
    border-radius: 0.703125rem;
    display: inline-block;
    vertical-align: top;
    margin-right: 0.625rem;
    margin-bottom: 0.625rem;
    font-size: 0.75rem;
    padding: 0 0.46875rem;
  }
  .goods-eval-comment-list{
    width:100%;
  }
  .goods-eval-comment-each{
    width:100%;
    margin-bottom: 0.625rem;
    background-color: white;
  }
  .goods-eval-comment-each-head{
    width:21.4375rem;
    height: 2rem;
    line-height: 2rem;
    margin: 0 auto;
  }
  .goods-eval-comment-each-head div{
    display: inline-block;
    vertical-align: top;
  }
  .goods-eval-comment-each-partyImg{
    width:1.75rem;
    height: 1.75rem;
    margin-top: 0.5rem;
  }
  .goods-eval-comment-each-partyName{
    color:#333;
    font-size:0.6875rem;
    margin-top: 0.2rem;
  }
  .goods-eval-comment-each-head div .van-image{
    width:1.75rem;
    height: 1.75rem;
    border-radius: 5.625rem;
  }
  .goods-eval-comment-each-content{
    width:21.4375rem;
    font-size:0.875rem;
    color:#33312E;
    margin:0.5rem auto;
    padding-bottom: 0.5rem;
  }
  .goods-eval-comment-each-photo{
    margin: 0 auto;
    width:21.4375rem;
  }
  .goods-eval-comment-each-photo .van-image{
    width:5rem;
    height: 5rem;
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .goods-eval-comment-each-time{
    color:#9E9E9E;
    font-size:0.625rem;
    width:21.4375rem;
    margin: 0.5rem auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/goods/goodsEvaluation.vue